import * as React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from '@material-ui/core';

function AreYouSureModal({
  open,
  message,
  onClose,
  onConfirm,
}: {
  open: boolean;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="are-you-sure-title"
      aria-describedby="are-you-sure-description"
    >
      <DialogTitle id="are-you-sure-title">Please confirm</DialogTitle>
      <DialogContent>
        <DialogContentText id="are-you-sure-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          No
        </Button>
        <Button onClick={onConfirm} color="primary" autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AreYouSureModal;



// WEBPACK FOOTER //
// ./src/modules/shared/dataSharing/AreYouSureModal.tsx